import { cva, type VariantProps } from 'class-variance-authority';

import type { JSX } from 'react';

import { cn, type TIcon } from '~/utils';
import { Text } from '~/components/text';
import { HStack } from '~/components/stack';

const iconVariants = cva(cn('size-4 fill-blueBonnet-500 shrink-0'), {
  variants: {
    variant: {
      default: '',
      destructive: 'fill-desire-500',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const textVariants = cva(cn('flex-1'), {
  variants: {
    variant: {
      default: '',
      destructive: 'text-desire-500',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

interface IIconLabelProps extends VariantProps<typeof iconVariants> {
  icon: TIcon;
  text?: string;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

export function IconLabel({
  icon,
  text,
  variant,
  className,
  iconClassName,
  textClassName,
}: IIconLabelProps): JSX.Element {
  const Icon = icon;

  return (
    <HStack className={cn('items-center gap-2', className)}>
      <Icon
        className={iconVariants({
          variant,
          className: iconClassName,
        })}
      />
      <Text
        className={textVariants({
          variant,
          className: textClassName,
        })}
      >
        {text}
      </Text>
    </HStack>
  );
}
